import React from 'react';
import logo from '../../assets/images/site/mobiliis-logo.png';
import { NAV_ITEMS, SITE_URL, LOGIN_PATH, SIGNUP_PATH, SHOW_HEADER_BUTTONS, headerButtons } from './siteLinks';

/**
 * The public pages' header: the main website's own (www.mobiliis.com), the same markup and styles (site.scss), so
 * moving between the sites changes nothing: the logo to the main website, its menu to its sections, its "Get in touch"
 * pill, and after it "Log in" (outlined) and "Start free trial" (navy pill; outlined on the sign-in page, whose one
 * Primary is Log In; only while sign-up is open: signupInfo from signup/info). Folds into the ☰ button as there.
 * Log in and Start free trial only while SHOW_HEADER_BUTTONS is on (siteLinks.js): off until the live main website has them.
 * props: page ('signup' | 'login' | 'terms'), signupInfo (null while not known or not open), showButtons (tests only)
 */
class SiteHeader extends React.Component {
	constructor(props) {
		super(props);
		this.state = { open: false };
	}

	render() {
		const { page, signupInfo } = this.props;
		const { open } = this.state;
		const buttons = headerButtons(page, signupInfo, this.props.showButtons !== undefined ? this.props.showButtons : SHOW_HEADER_BUTTONS);
		return (
			<header className={'site-header' + (buttons.login || buttons.trial ? ' with-buttons' : '')}>
				<div className="wrap header-inner">
					<a href={SITE_URL} className="brand">
						<img src={logo} alt="Mobiliis" className="brand-logo" />
					</a>
					<button className="nav-toggle" type="button" aria-expanded={open ? 'true' : 'false'} aria-controls="primaryNav" aria-label="Toggle menu"
						onClick={() => this.setState({ open: !open })}>
						<span></span><span></span><span></span>
					</button>
					<nav className={'primary-nav' + (open ? ' open' : '')} id="primaryNav">
						{NAV_ITEMS.map((item) => (
							<a key={item.href} href={item.href} className={item.cta ? 'nav-cta' : undefined}>{item.label}</a>
						))}
						{buttons.login && <a href={LOGIN_PATH} className="nav-login">Log in</a>}
						{buttons.trial && <a href={SIGNUP_PATH} className={buttons.trialKind === 'primary' ? 'nav-cta' : 'nav-login'}>Start free trial</a>}
					</nav>
				</div>
			</header>
		);
	}
}

export default SiteHeader;
